import { Component, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { CanvasService } from 'src/app/predictor/services/canvas.service';
import { PredictorModelActions } from 'src/app/state/predictor-model/predictor-model.actions';
import { PredictorModelState } from 'src/app/state/predictor-model/predictor-model.state';
import { CanvasLayer } from '../../interfaces/canvas-layer';

@Component({
  selector: 'app-scenario-selection-modal',
  templateUrl: './scenario-selection-modal.component.html',
  styleUrls: ['./scenario-selection-modal.component.scss'],
})
export class ScenarioSelectionModalComponent implements OnInit {
  scenarios: CanvasLayer[] = [];

  constructor(private store: Store, public canvasService: CanvasService, public ref: DynamicDialogRef) {}

  ngOnInit(): void {
    this.scenarios = this.store.selectSnapshot(PredictorModelState.scenarios)
  }
  
  scenariosChange() {
    this.store.dispatch(new PredictorModelActions.UpdateScenarios([...this.scenarios]));
    this.canvasService.setLayerVisibility(this.scenarios)
  }
}
